import React from 'react';

export const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g id="Outline/close_circle">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.69592C6.47715 2.69592 2 7.17308 2 12.6959C2 18.2188 6.47715 22.6959 12 22.6959C17.5228 22.6959 22 18.2188 22 12.6959C22 7.17308 17.5228 2.69592 12 2.69592ZM12 4.69592C16.4183 4.69592 20 8.27764 20 12.6959C20 17.1142 16.4183 20.6959 12 20.6959C7.58172 20.6959 4 17.1142 4 12.6959C4.00496 8.2797 7.58378 4.70088 12 4.69592ZM15 17.1789L16.483 15.6959L13.483 12.6959L16.483 9.69592L15 8.21292L12 11.2129L9 8.21292L7.517 9.69592L10.517 12.6959L7.517 15.6959L9 17.1789L12 14.1789L15 17.1789Z"
          fill="#CC0033"
        />
      </g>
    </svg>
  );
};
